import { WorkflowEntityModel } from "src/store/models/entity/workflow/entity";
import { WorkflowHelperModel } from "src/store/models/entity/workflow/helper";

export const encooWorkflowModels = {
  entity: WorkflowEntityModel,
  helper: WorkflowHelperModel,
};
